import { render, staticRenderFns } from "./ModalPaySBP.vue?vue&type=template&id=5af5481a&scoped=true&"
import script from "./ModalPaySBP.vue?vue&type=script&lang=js&"
export * from "./ModalPaySBP.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaySBP.vue?vue&type=style&index=0&id=5af5481a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5481a",
  null
  
)

export default component.exports